import { useState, useRef, useEffect } from "react";
import { Mail } from "lucide-react";
import qrImage from "../Assets/right_img_wow_review_qr.jpg";
import wowLogo from "../Assets/newLogo.png";
import "react-phone-input-2/lib/style.css";
import { storeData } from "../LocalConnection/LocalConnection";
import {
  server_post_data,
  login_user_email,
  get_bus_counter_by_id,
} from "../ServiceConnection/serviceconnection";
import { handleEmailRegex, handleError } from "../CommonJquery/CommonJquery";
import { useNavigate } from "react-router-dom";
import AppleLogin from "react-apple-login";
// import "../../../CSS/NewOnboading/Step6.css"
// Google Sign In imports
import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";

let click_one = 0;
export default function NewLoginPage() {
  const navigate = useNavigate();
  const [otp, setOtp] = useState(["", "", "", ""]);

  const [timer, setTimer] = useState(60);
  const [mobileNumber, setMobileNumber] = useState("");
  const [mobileNumberOnly, setMobileNumberOnly] = useState("");
  const [UserName, setUserName] = useState("");
  const [canResend, setCanResend] = useState(true);
  const [canResendEdit, setCanResendEdit] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [isOtpValid, setIsOtpValid] = useState(true);
  const [IsLoading, setIsLoading] = useState(false);
  const [correctOtp, setcorrectOtp] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [zipCode, setZIpCOde] = useState("");
  const [EmailIDNumber, setEmailIDNumber] = useState("");
  const [appleSDKLoaded, setAppleSDKLoaded] = useState(false);

  // Create refs for each OTP input
  const otpRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];

  // Handle OTP input change
  const handleOtpChange = (e, index) => {
    const value = e.target.value;

    // Only allow digits
    if (value && !/^\d+$/.test(value)) {
      return;
    }

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 3) {
      otpRefs[index + 1].current.focus();
    }

    if (value !== correctOtp) {
      // ✅ Clear error on input
      setIsOtpValid(true);
    } else {
      // ✅ Clear error on input
      setIsOtpValid(false);
    }
  };

  // Handle keydown events for OTP inputs
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (index > 0 && otp[index] === "") {
        otpRefs[index - 1].current.focus();
      }
    }

    if (e.key === "ArrowLeft" && index > 0) {
      otpRefs[index - 1].current.focus();
    }

    if (e.key === "ArrowRight" && index < 3) {
      otpRefs[index + 1].current.focus();
    }
  };

  // Handle pasting OTP
  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text/plain").trim();

    if (/^\d{4}$/.test(pastedData)) {
      const newOtp = pastedData.split("");
      setOtp(newOtp);
      otpRefs[3].current.focus();
      setIsOtpValid(false);
    }
  };
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === "Enter" && otp.join("").length >= 4) {
        handleNext();
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [otp]); // ✅ Dependency added to react to latest otp value

  const handleNext = () => {
    const enteredOtp = otp.join("");
    if (enteredOtp === correctOtp) {
      setIsOtpValid(true);
      handleSubmit(2);
    } else {
      setIsOtpValid(false);
    }
  };

  useEffect(() => {
    let interval;
    if (timer > 0 && !canResend) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      clearInterval(interval);
      setCanResendEdit(true);
      setCanResend(true);
    }
    return () => clearInterval(interval);
  }, [timer, canResend]);

  const handleSubmit = async (flag, email = "", loginType = "normal") => {
    const emailToValidate = email || EmailIDNumber;
    if (emailToValidate.trim() === "") {
      setError("");
      setIsValid(false);
      return;
    } else if (!validateEmail(emailToValidate)) {
      setError("Please enter a valid email address");
      setIsValid(false);
      return;
    } else {
      setError("");
      setIsValid(true);
    }
    if (isOtpValid || flag == 1) {
      if (click_one == 0) {
        click_one = 1;
        setIsLoading(true);

        var formdata = new FormData();
        formdata.append("mobile_no", mobileNumberOnly);
        formdata.append("user_name", UserName);
        formdata.append("otp", otp.join(""));
        formdata.append("zip_code", "+" + zipCode);
        if (email === "") {
          formdata.append("user_email", EmailIDNumber);
          formdata.append("by_login", "normal");
          formdata.append("flag", flag);
        } else {
          formdata.append("user_email", email);
          formdata.append("flag", "1");
          formdata.append("by_login", loginType);
        }

        await server_post_data(login_user_email, formdata)
          .then(async (Response) => {
            click_one = 0;
            setIsLoading(false);
            const data = Response.message.split("~@~");
            const final_data2 = JSON.parse(data[1]);
            if (parseInt(data[0]) === 1) {
              handleError(final_data2.message);
            } else {
              const final_data = final_data2.user_data;
              if (flag === 1) {
                setOtpSent(true);
                setCanResendEdit(false);
                setcorrectOtp(final_data[0].bus_otp);
                setTimer(60);
                setCanResend(false);
              } else if (flag === 2) {
                storeData("final_user_moblie_no", final_data[0].mobile_no);
                storeData("customer_id", final_data[0].buu_id);
                storeData("step_save", final_data[0].step_save);
                if (Number.parseInt(final_data[0].bus_id) !== 0) {
                  click_one = 1;
                  var formdata22 = new FormData();
                  formdata22.append("bus_id_for", final_data[0].bus_id);
                  setIsLoading(true);
                  await server_post_data(get_bus_counter_by_id, formdata22)
                    .then(async (Response) => {
                      click_one = 0;
                      setIsLoading(false);
                      const data = Response.message.split("~@~");
                      const final_data2222 = JSON.parse(data[1]);
                      if (parseInt(data[0]) === 1) {
                        handleError(final_data2222.message);
                      } else {
                        storeData("final_full_name", final_data[0].full_name);
                        storeData("final_user_email", final_data[0].email_id);
                        storeData("final_bus_id", final_data[0].bus_id);
                        storeData("user_image", final_data[0].image);
                        storeData("access_token", final_data[0].access);
                        storeData("refresh_token", final_data[0].refresh);
                        storeData(
                          "price_amount_package",
                          final_data2222.package_amount,
                        );
                        storeData(
                          "counter_bus_id",
                          final_data2222.count_session,
                        );
                        storeData(
                          "user_image_path",
                          final_data2222.user_linkss_link,
                        );
                        navigate("/");
                      }
                    })
                    .catch((error) => {
                      click_one = 0;
                      setIsLoading(false);
                      handleError("network");
                    });
                } else {
                  navigate("/onboarding");
                }
              }
            }
          })
          .catch((error) => {
            click_one = 0;
            setIsLoading(false);
            handleError("network");
          });
      }
    } else {
      alert("Invalid OTP");
    }
  };

  const handleEditNo = () => {
    setOtpSent(false);
    setCanResend(true);
    setCanResendEdit(true);
    setOtp(["", "", "", ""]);
  };
  const handleResendOtp = () => {
    if (!isValid) {
      return;
    }
    setCanResendEdit(false);
    setCanResend(false);
    setTimer(60);
    handleSubmit(1);
  };

  // email input Function
  const [error, setError] = useState("");
  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  const handleEmail = (e) => {
    const value = e.target.value;
    setEmailIDNumber(value);
    if (value.length > 0) {
      setError("");
      setIsValid(true);
    } else {
      setError("");
      setIsValid(false);
    }
  };

  // Google Sign In handlers
  const handleGoogleLoginSuccess = async (credentialResponse) => {
    try {
      // Decode the JWT token from Google
      const decoded = jwtDecode(credentialResponse.credential);

      // Extract user information
      const { email, name, picture, sub } = decoded;
      setEmailIDNumber(email);
      handleSubmit(2, email, "google");
    } catch (error) {
      console.error("Google login error:", error);
      handleError("Failed to process Google login");
      setIsLoading(false);
    }
  };

  const handleGoogleLoginError = () => {
    console.error("Google login failed");
    handleError("Google login failed. Please try again.");
  };

  // Apple Sign In handlers - UPDATED VERSION

  // Load Apple Sign In JS SDK with better error handling
  useEffect(() => {
    const loadAppleSignInSDK = () => {
      // Only load if not already loaded
      if (!document.getElementById("appleid-signin-js") && !window.AppleID) {
        const script = document.createElement("script");
        script.id = "appleid-signin-js";
        script.src =
          "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";
        script.async = true;
        script.defer = true;

        // Add event listeners to track loading status
        script.onload = () => {
          setAppleSDKLoaded(true);
        };

        script.onerror = (error) => {
          console.error("Failed to load Apple Sign In SDK", error);
          setAppleSDKLoaded(false);
        };

        document.body.appendChild(script);
      } else if (window.AppleID) {
        setAppleSDKLoaded(true);
      }
    };

    loadAppleSignInSDK();

    // Check if SDK is loaded every second for up to 10 seconds
    const checkInterval = setInterval(() => {
      if (window.AppleID) {
        setAppleSDKLoaded(true);
        clearInterval(checkInterval);
      }
    }, 1000);

    // Clear interval after 10 seconds to prevent memory leaks
    const timeoutId = setTimeout(() => {
      clearInterval(checkInterval);
      if (!window.AppleID) {
        console.warn("Apple Sign In SDK failed to load after 10 seconds");
      }
    }, 10000);

    return () => {
      clearInterval(checkInterval);
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <div className="container-fluid p-0 mobile_height_clss">
      <div className="row no-gutters full-height">
        {/* Left side - Login Form */}
        <div className="col-lg-6">
          <div className="wowLogoiv">
            <img
              className="wowRemogoOnboading"
              src={wowLogo || "/placeholder.svg"}
              alt="wowLogo"
            />
          </div>
          <div className="col-md-7 m-auto">
            <div className="login_container">
              <h1>Sign Up</h1>
              <p>
                or <span>Login</span> into an existing account
              </p>

              <div className="loginInputCntrr">
                {/* <PhoneInput
                  country={"in"}
                  onlyCountries={["in"]}
                  value={mobileNumber}
                  onChange={handleChange}
                  preferredCountries={["in"]}
                  inputProps={{
                    name: "mobile",
                    required: true,
                    autoFocus: false,
                    readOnly: otpSent,
                  }}
                  placeholder="Mobile No."
                  inputClass="phone-input"
                  containerClass="phone-container"
                  buttonClass="phone-dropdown"
                  disableSearchIcon={true}
                  enableSearch={false}
                  countryCodeEditable={false}
                  style={{
                    opacity: otpSent ? 0.7 : 1,
                    pointerEvents: otpSent ? "none" : "auto",
                  }}
                /> */}
                <div
                  className="email_input_div input-group mb-3"
                  style={{ position: "relative" }}
                >
                  <div className="input-group-prepend">
                    <span
                      className={`input-group-text ${
                        error ? "is-invalid-span" : ""
                      }`}
                      id="email-addon"
                    >
                      <Mail size={20} />
                    </span>
                  </div>
                  <input
                    type="text"
                    className={`form-control ${error ? "is-invalid" : ""}`}
                    placeholder="Enter Email"
                    aria-label="Email"
                    aria-describedby="email-addon"
                    value={EmailIDNumber}
                    onChange={handleEmail}
                    onKeyUp={handleEmailRegex}
                    readOnly={otpSent}
                    style={{
                      opacity: otpSent ? 0.7 : 1,
                      pointerEvents: otpSent ? "none" : "auto",
                    }}
                  />
                  {otpSent && EmailIDNumber.length >= 2 && (
                    <button
                      type="button"
                      className="logn_edit_bbttn"
                      onClick={handleEditNo}
                    >
                      Edit
                    </button>
                  )}
                  {error && <div className="invalid-feedback">{error}</div>}
                </div>
              </div>

              <div className="oneTimePassword">
                {otpSent && (
                  <>
                    <div className="oneTimePassword">
                      <label className="otp-label">One Time Password</label>
                      <div className="otp-inputs">
                        {otp.map((digit, index) => (
                          <input
                            key={index}
                            ref={otpRefs[index]}
                            type="text"
                            maxLength="1"
                            className="otp-box"
                            value={digit}
                            onChange={(e) => handleOtpChange(e, index)}
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            onPaste={index === 0 ? handlePaste : null}
                          />
                        ))}
                      </div>
                      <div
                        className="d-flex justify-content-between align-items-center "
                        style={{ marginTop: "8px" }}
                      >
                        {/* ✅ OTP Error Message */}
                        {!isOtpValid && (
                          <span
                            style={{
                              fontSize: "12px",
                              color: "red",
                              display: "block",
                            }}
                          >
                            Please fill correct OTP
                          </span>
                        )}
                        {canResendEdit ? (
                          <button
                            className="resend_otp_txt"
                            type="button"
                            onClick={handleResendOtp}
                          >
                            Resend
                          </button>
                        ) : (
                          <span
                            className="resend_otp_txt"
                            style={{
                              color:
                                canResend && isValid && otpSent
                                  ? "var(--primary-600)"
                                  : "gray",
                              cursor:
                                isValid && canResend && otpSent
                                  ? "pointer"
                                  : "default",
                              float: "right",
                            }}
                          >
                            Resend {canResend ? "" : `(${timer}s)`}
                          </span>
                        )}
                      </div>
                      {/* ✅ OTP Error Message */}
                    </div>

                    <button
                      type="button"
                      className="login_bbtn"
                      style={{
                        opacity: otp.every((digit) => digit !== "") ? 1 : 0.5,
                        pointerEvents: otp.every((digit) => digit !== "")
                          ? "auto"
                          : "none",
                      }}
                      onClick={handleNext}
                      disabled={otp.join("").length < 4}
                    >
                      Verify
                    </button>
                  </>
                )}
              </div>

              {!otpSent && (
                <button
                  type="button"
                  className="login_bbtn"
                  onClick={() => handleSubmit(1)}
                  style={{
                    opacity: EmailIDNumber.length === 0 ? 0.5 : 1,
                    pointerEvents: EmailIDNumber.length === 0 ? "none" : "auto",
                  }}
                  disabled={EmailIDNumber.length === 0}
                >
                  Login
                </button>
              )}

              {/* Social Sign In Buttons */}
              {!otpSent && (
                <div
                  className="social-signin-container"
                  style={{ marginTop: "20px" }}
                >
                  <div
                    className="separator"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      margin: "15px 0",
                    }}
                  >
                    <div
                      style={{
                        flex: "1",
                        height: "1px",
                        backgroundColor: "#ddd",
                      }}
                    ></div>
                    <span
                      style={{
                        padding: "0 10px",
                        color: "#6c757d",
                        fontSize: "14px",
                      }}
                    >
                      OR
                    </span>
                    <div
                      style={{
                        flex: "1",
                        height: "1px",
                        backgroundColor: "#ddd",
                      }}
                    ></div>
                  </div>

                  {/* Google Sign In Button */}
                  <div
                    id="google-signin-button"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: "10px",
                    }}
                  >
                    <GoogleLogin
                      onSuccess={handleGoogleLoginSuccess}
                      onError={handleGoogleLoginError}
                      useOneTap
                      theme="filled_blue"
                      text="signin_with"
                      shape="rectangular"
                      logo_alignment="center"
                      width="100%"
                    />
                  </div>
                  <AppleLogin
                    clientId={"com.wowreviews.signin"}
                    redirectURI={"https://app.wowreviews.co/callbackapple"}
                    responseType={"code"}
                    responseMode={"query"}
                    scope="email"
                    usePopup={false}
                    designProp={{
                      height: 38,
                      width: 259,
                      color: "black",
                      border: false,
                      type: "sign-in",
                      border_radius: 15,
                      scale: 1,
                      locale: "en_US",
                    }}
                  />
                </div>
              )}

              <p className="login_note">
                By clicking on Login, I accept the{" "}
                <span>
                  <a
                    href=" https://www.wowreviews.co/termsandcondition"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ fontWeight: "600" }}
                  >
                    {" "}
                    Terms & Conditions
                  </a>{" "}
                  &{" "}
                  <a
                    href="https://www.wowreviews.co/privacypolicy"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ fontWeight: "600" }}
                  >
                    Privacy Policy
                  </a>
                </span>
              </p>
            </div>
          </div>
        </div>

        <div className="col-lg-6 dispyNone768">
          <div className="right_img_wow_review">
            <img src={qrImage || "/placeholder.svg"} alt="QR Code Scanner" />
          </div>
        </div>
      </div>
    </div>
  );
}
